module.exports = __webpack_public_path__ + "static/img/备案图标.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/备案图标.png
// module id = 1427
// module chunks = 1